import { Copy, Printer, Share2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function DocumentActions({ text, summary }) {
  const copyDraft = () => {
    navigator.clipboard.writeText(text);
    toast.success("Draf disalin ke clipboard.");
  };
  const share = async () => {
    const payload = summary || text.slice(0, 200);
    if (navigator.share) {
      try { await navigator.share({ title: "BergerakNyata — Rencana Aksi", text: payload }); return; } catch { /* cancelled */ }
    }
    navigator.clipboard.writeText(payload);
    toast.success("Ringkasan disalin — siap dibagikan.");
  };
  return (
    <div className="flex flex-wrap gap-2 mt-4">
      <Button data-testid="planner-copy-btn" size="sm" onClick={copyDraft} className="rounded-full bg-slate-900 hover:bg-slate-700 text-white font-bold">
        <Copy className="w-3.5 h-3.5 mr-1.5" /> Salin Draf
      </Button>
      <Button data-testid="planner-print-btn" size="sm" onClick={() => window.print()} variant="outline" className="rounded-full font-bold">
        <Printer className="w-3.5 h-3.5 mr-1.5" /> Cetak / Simpan PDF
      </Button>
      <Button data-testid="planner-share-btn" size="sm" onClick={share} variant="outline" className="rounded-full font-bold">
        <Share2 className="w-3.5 h-3.5 mr-1.5" /> Bagikan Ringkasan
      </Button>
    </div>
  );
}
